import React, { Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-regular-svg-icons';

const DriversLicenseRequirements = ({ bad, children, description, good }) => (
  <Fragment>
    <p>{description}</p>
    <div className="container-list">
      <ul className="rounded-list">
        {good.map(text => (
          <li key={text}>
            <div>
              <FontAwesomeIcon icon={faCheckCircle} />
            </div>
            <div>{text}</div>
          </li>
        ))}
      </ul>

      <ul className="rounded-list-red">
        {bad.map(text => (
          <li key={text}>
            <div>
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
            <div>{text}</div>
          </li>
        ))}
      </ul>
    </div>

    {children}
  </Fragment>
);
export default DriversLicenseRequirements;



// WEBPACK FOOTER //
// ./src/components/MissingDocs/Requirements.js